import React, { useState, useEffect } from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import { sidebarItemsPlugin, sidebarItemsTool } from "./sidebarData";

const SidebarComponent = ({ type }) => {
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const sidebarItems = type === 'tool' ? sidebarItemsTool : sidebarItemsPlugin;
  useEffect(() => {
    const path = location.pathname + location.search;
    const activeSection = sidebarItems.findIndex(section =>
      section.items.some(item => path.includes(item.href))
    );

    if (activeSection !== -1) {
      setActiveKey(sidebarItems[activeSection].eventKey);
      const selectedItem = sidebarItems[activeSection].items.find(item => path.includes(item.href));
      setSelectedItem(selectedItem ? selectedItem.href : null);
    }
  }, [location.pathname, location.search, sidebarItems]);

  const handleToggle = (eventKey) => {
    setActiveKey(eventKey);
  };

  const handleSelect = (itemHref) => {
    setSelectedItem(itemHref);
  };

  return (
    <div
      className="bg-light border-right h-100 sticky-top"
      style={{ minHeight: "100vh", fontSize: "14px" }}
    >
      <Accordion activeKey={activeKey} className="py-4">
        {sidebarItems.map((section, index) => (
          <Card key={index} className="mb-2 border-0">
            <Card.Header className="p-0" style={{ backgroundColor: "#fff" }}>
              <Button
                variant="link"
                onClick={() => handleToggle(section.eventKey)}
                className={`d-flex align-items-center w-100 text-left ${activeKey === section.eventKey ? "active" : ""}`}
                style={{
                  textDecoration: "none",
                  color: "#000",
                  padding: "0.5rem 1rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "transparent",
                }}
              >
                {section.items.length > 0 ? (
                  <>
                    <p className="mb-0 flex-grow-1">{section.sectionTitle}</p>
                    <span className="ml-2">
                      {activeKey === section.eventKey ? (
                        <FaChevronDown style={{ color: "#6c757d" }} />
                      ) : (
                        <FaChevronRight style={{ color: "#6c757d" }} />
                      )}
                    </span>
                  </>
                ) : (
                  <Link
                    to={`/documentation${section.href}`}
                    className={`d-block py-1 ${selectedItem === section.href ? "selected" : ""}`}
                    style={{
                      textDecoration: "none",
                      color: selectedItem === section.href ? "#eebb6b" : "#000",
                      backgroundColor: "transparent",
                      transition: "color 0.3s ease, background-color 0.3s ease",
                    }}
                    onClick={() => handleSelect(section.href)}
                  >
                    {section.sectionTitle}
                  </Link>
                )}
              </Button>
            </Card.Header>
            {section.items.length > 0 && (
              <Accordion.Collapse eventKey={section.eventKey}>
                <Card.Body className="pl-3 py-2">
                  <ul className="list-unstyled mb-0">
                    {section.items.map((item, itemIndex) => (
                      <li key={itemIndex}>
                        <Link
                          to={`/documentation${item.href}`}
                          className={`d-block py-1 ${selectedItem === item.href ? "selected" : ""}`}
                          style={{
                            paddingLeft: "1rem",
                            textDecoration: "none",
                            color: selectedItem === item.href ? "#eebb6b" : "#000",
                            backgroundColor: "transparent",
                            transition: "color 0.3s ease",
                          }}
                          onClick={() => handleSelect(item.href)}
                        >
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Card.Body>
              </Accordion.Collapse>
            )}
          </Card>
        ))}
      </Accordion>
    </div>
  );
};

export default SidebarComponent;
